import { Component, computed, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { MediaContent, StepContent, VideoContent, Form } from 'matchmaking/models';
import {
    MatchmakingApiService,
    MatchmakingDataService,
    MatchmakingTranslateService,
    TrackingMatchmakingSnowplowService,
} from 'matchmaking/services';
import { SpacerComponent } from '@sirius/common';
import { FormBackButtonComponent } from '../form-back-button/form-back-button.component';
import { KeyBenefitsComponent } from '../key-benefits/key-benefits.component';
import { CaseStoriesComponent } from '../case-stories/case-stories.component';
import { VideosComponent } from '../videos/videos.component';
import { FormularComponent } from '../formular/formular.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'matchmaking-step-preview',
    imports: [FormBackButtonComponent, KeyBenefitsComponent, CaseStoriesComponent, VideosComponent, FormularComponent, TranslateModule, SpacerComponent],
    templateUrl: './step-preview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './step-preview.component.scss'
})
export class StepPreviewComponent implements OnInit {
    translateService = inject(MatchmakingTranslateService);
    dataService = inject(MatchmakingDataService);
    apiService = inject(MatchmakingApiService);
    trackingService = inject(TrackingMatchmakingSnowplowService);

    caseStories = input<MediaContent[] | undefined>([]);
    videos = input<VideoContent[] | undefined>([]);
    content = input<StepContent>();
    form = input<Form>();

    industry = computed(() => this.dataService.selectedIndustryTitle());
    application = computed(() => this.dataService.selectedApplicationTitle());
    translations = computed(() => this.translateService.translations());

    ngOnInit() {
        const config = this.dataService.config();
        if (config) {
            this.trackingService.trackStepStart({ step_number: 5, step_name: config.currentStep });
        }
    }

    handleBack() {
        this.apiService.goToPreviousStep();
    }
}
